module.exports = __webpack_public_path__ + "static/media/index.1d2dad41.less";